import React, { useEffect } from 'react';

interface HealthCheckProps {
  appName: string;
}

export const HealthCheckListener: React.FC<HealthCheckProps> = ({ appName }) => {
  useEffect(() => {
    const onMessageHandler = (event: MessageEvent) => {
      try {
        const data = JSON.parse(event.data);

        if (data.request === 'healthcheck') {
          // the response to the health check should go back to every source asking for it
          const message: string = JSON.stringify({ status: 'ok', appName });
          const opts: WindowPostMessageOptions = { targetOrigin: event.origin };

          event.source?.postMessage(message, opts);
        }
      } catch {
        // ignore message with non-JSON data
      }
    };

    window.addEventListener('message', onMessageHandler);

    return () => window.removeEventListener('message', onMessageHandler);
  }, []);

  return null;
};
